import { REP_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'billableHours',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Billable Hours',
  },
}

const keys = {
  statKey: 'billable_hours',
  componentKeys: [REP_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
  convertTo: 'hours',
}

const billableHours = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { billableHours }
